
export class DebouncedContext<T> {
    private controller: AbortController | null = null
    private debounceTimer: NodeJS.Timeout | null = null;
    private readonly debounceTime: number;

    constructor(debounceTime: number= 200) {
        this.debounceTime = debounceTime;
    }

    public async execute(call: (controller: AbortController) => Promise<T>): Promise<T> {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        this.controller?.abort("reason");
        this.controller = new AbortController();

        return await new Promise((resolve) => {
            this.debounceTimer = setTimeout(() => {
                resolve(call(this.controller!!))
            }, this.debounceTime)
        })
    }
}
